'use client'

import React, { useEffect } from 'react'
import { add, init } from '@amplitude/analytics-browser'

import { privacyPlugin } from '@/lib/amplitude/privacyPlugin'

interface AmplitudeProviderProps {
  children: React.ReactNode
}

export default function AmplitudeProvider({ children }: AmplitudeProviderProps) {
  useEffect(() => {
    const apiKey = process.env.AMPLITUDE_API_KEY || ''
    if (apiKey) {
      // Registered before init so the page view that init fires on load goes through it too.
      add(privacyPlugin)
      init(apiKey, undefined, {
        defaultTracking: {
          sessions: true,
          pageViews: true,
          formInteractions: true,
          // Download links are presigned document URLs: the file name and the signature are
          // customer content and a credential.
          fileDownloads: false,
        },
        // The IP address is personal data and only yields coarse geography; country comes from
        // the server-side country_code user property and the timezone from the browser.
        trackingOptions: { ipAddress: false },
      })
    }
  }, [])

  return <>{children}</>
}
